import React from "react";
import OffcanvasWrapper from "../component/OffcanvasWrapper";
import { Button, FloatingLabel, Form } from "olive-react-myoneui";
import DropdownCommon from "../component/DropdownCommon";

const AddEditOffcanvas = ({
  show,
  onClose,
  type,
  handleChange,
  title,
  selectedChapter,
  chapters,
  setSelectedChapter,
  searchValue,
  setSearchValue,
  hasMore,
  handleLoadMore,
  isLoading,
  onSubmit,
  onButtonLoading,
  errors = {},
}) => {
  return (
    <OffcanvasWrapper
      show={show}
      onClose={onClose}
      title={`${type === "edit" ? "Edit" : "add" ? "Add" : ""} Section`}
      footer={
        <>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSubmit}>
            {onButtonLoading ? "Saving..." : "Save"}
          </Button>
        </>
      }
    >
      <p className="help-text fs-6 fw-semibold">
        Please enter the section title and select the chapter(s) below.
      </p>
      <div className="mb-4">
        <FloatingLabel controlId="sectionId" label={<span className={errors?.title && "text-danger"}>Title *</span>}>
          <Form.Control
            type="text"
            placeholder="title"
            name="title"
            value={title}
            onChange={handleChange}
            isInvalid={!!errors?.title}
          />
        </FloatingLabel>
        {errors?.title && <div className="text-danger mt-1">{errors.title}</div>}
      </div>
      <div className="mb-4">
        <DropdownCommon
          name="selectedChapter"
          selectedValue={selectedChapter}
          setSelectedValue={setSelectedChapter}
          items={chapters}
          label={<span className={errors?.chapter && "text-danger"}>Chapter *</span>}
          searchable={true}
          remoteSearch={true}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          hasMore={hasMore}
          onLoadMore={handleLoadMore}
          isLoading={isLoading}
        />
        {errors?.chapter && <div className="text-danger mt-1">{errors.chapter}</div>}
      </div>
    </OffcanvasWrapper>
  );
};

export default AddEditOffcanvas;
